<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool">
      <template slot="text">位置标注点列表</template>
      <template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </template>
    </selectTool>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(240)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增标段' : '编辑标段'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; position: relative">
        <duobianxing ref="duobianxing"></duobianxing>
        <div id="sderwwetcsd">
          <Form
            ref="item"
            :model="item"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="名称" prop="name">
                  <Input v-model="item.name" placeholder="请输入"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="单位名称" prop="groupName">
                  <selectGroup
                    :name="item.groupName"
                    @update:name="item.groupName = $event"
                    :id="item.groupId"
                    @update:id="item.groupId = $event"
                  >
                  </selectGroup>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="备注" prop="remark">
                  <Input
                    v-model="item.remark"
                    type="textarea"
                    placeholder="请输入"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Col span="24">
                <Button type="primary" long @click="addUpdate('item')"
                  >提交表单</Button
                >
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import duobianxing from "../map/duobianxing.vue";
export default {
  components: { duobianxing },
  data() {
    return {
      openForm: false,
      zhouqiModel: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },

        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        coordList: [],
        cs: 2, //	坐标系（1-WGS84，2-GCJ-02，3-BD-09）
        name: "",
        remark: "",
        groupName: "",
        groupId: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      deviceList: [],
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        total: 0,
        keyword: "",
      },
      searchForms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
        },
        {
          title: "关键词",
          key: "keyword",
          type: "Input",
        },
      ],
    };
  },
  methods: {
    reZhouwi(v) {
      this.formItem = v;
      console.log(v);
      this.item.timeList = v.times;
      this.item.weekList = v.days;
      this.zhouqiModel = false;
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/landmark/list",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var ccc = this.$refs.duobianxing.getPoints();
      this.item.coordList = ccc;
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.gc + "/landmark/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.gc + "/landmark/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.gc + "/landmark/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.getItem(row, 1);
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/landmark/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (type == 1) {
            var data = res.data.data.coordList;
            this.$refs.duobianxing.reData(data);
          }
        }
      });
    },
    openBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (let i = 0; i < data.length; i++) {
        deviceIdList.push(data[i].id);
      }
      axios({
        method: "post",
        url: axios.rule + "/fence/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    openZhouqi() {
      this.zhouqiModel = true;
      var ddd = {
        days: [],
        times: [],
      };
      this.$refs.zhouqi.reData(ddd);
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.searchItem.pageNumber = 1;
      this.getList();
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/garbage/landmark.vue